const comments = [
  {
    name: '吃瓜群众小王',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20profile%20avatar%20on%20dark%20background%2C%20minimal%20geometric%20design%2C%20neutral%20tone%2C%20clean%20and%20modern&width=80&height=80&seq=comment-avatar-01&orientation=landscape',
    text: '这个平台真的太强了！每次有热点事件，这里总是第一时间更新，比微博热搜还快。关键是内容有料，不是那种标题党，每条爆料都有实锤证据，吃瓜吃得放心。',
    verified: true,
  },
  {
    name: '匿名网友007',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20anonymous%20profile%20icon%20on%20dark%20background%2C%20minimal%20design%2C%20mysterious%20vibe%2C%20clean%20aesthetic&width=80&height=80&seq=comment-avatar-02&orientation=landscape',
    text: '每天上班摸鱼就靠51爆料网了，编辑部太会选题了，每篇都是我想看的内容。尤其是明星绯闻板块，简直是我这种八卦爱好者的天堂！',
    verified: false,
  },
  {
    name: '资深娱记老李',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20professional%20profile%20avatar%20on%20dark%20background%2C%20minimal%20geometric%20style%2C%20editorial%20vibe%2C%20clean%20design&width=80&height=80&seq=comment-avatar-03&orientation=landscape',
    text: '作为行业从业者，我必须说51爆料网的内容质量在同类平台中属于顶尖水平。很多所谓的独家爆料在其他地方根本看不到，信息的深度和广度都让人印象深刻。',
    verified: true,
  },
  {
    name: '吃瓜美少女',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20feminine%20profile%20avatar%20on%20dark%20background%2C%20minimal%20design%2C%20soft%20geometric%20style%2C%20clean%20aesthetic&width=80&height=80&seq=comment-avatar-04&orientation=landscape',
    text: '从朋友那里知道这个网站的，一开始以为又是那种标题党网站，结果看了几篇就停不下来了。内容真实有料，更新速度也快，已经安利给身边所有喜欢八卦的朋友了！',
    verified: false,
  },
  {
    name: '真相追踪者',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20detective%20style%20profile%20avatar%20on%20dark%20background%2C%20minimal%20geometric%20design%2C%20investigative%20vibe%2C%20clean%20aesthetic&width=80&height=80&seq=comment-avatar-05&orientation=landscape',
    text: '在这个信息爆炸的时代，能找到一家真正专注于深度爆料的平台不容易。51爆料网的内容不仅速度快，更重要的是每条都有据可查，不是那种随便编的故事。强烈推荐！',
    verified: true,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="relative py-20 md:py-28 px-4 md:px-8 bg-background-100/50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-accent-500/10 text-accent-400 text-xs font-semibold rounded-full border border-accent-500/20 whitespace-nowrap mb-4">
            <i className="ri-chat-quote-line text-[10px]"></i>
            用户反馈
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 tracking-tight">
            吃瓜群众 <span className="font-heading italic text-accent-400">怎么说</span>
          </h2>
          <p className="text-foreground-400 text-sm mt-3 max-w-lg mx-auto">
            来自真实用户的声音，每一份认可都是我们继续前进的动力
          </p>
        </div>

        <div className="space-y-0">
          {comments.map((item, i) => (
            <div
              key={i}
              className={`flex gap-4 md:gap-6 py-6 md:py-8 ${
                i < comments.length - 1 ? 'border-b border-background-200/30' : ''
              }`}
            >
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden bg-background-200">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-sm font-semibold text-foreground-200">{item.name}</span>
                  {item.verified && (
                    <span className="w-4 h-4 flex items-center justify-center rounded-full bg-accent-500">
                      <i className="ri-check-line text-background-950 text-[10px]"></i>
                    </span>
                  )}
                </div>
                <p className="text-sm text-foreground-400 leading-relaxed italic font-heading">
                  &ldquo;{item.text}&rdquo;
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}